import React from "react";

import LandingArrowIcon from "./LandingArrowIcon";
import LandingCheckIcon from "./LandingCheckIcon";

export default function LandingSalesCard({
    variant = "standard",
    eyebrow,
    title,
    description,
    benefits = [],
    metrics = [],
    primaryAction,
    secondaryAction = null,
}) {
    return (
        <article
            className={`landing-sales-card landing-sales-card--${variant}`}
        >
            <div className="landing-sales-card__glow"/>

            <div className="landing-sales-card__content">
                <span className="landing-sales-card__eyebrow">
                    {eyebrow}
                </span>

                <h3>{title}</h3>

                <p>{description}</p>

                <ul className="landing-sales-card__benefits">
                    {benefits.map((benefit) => (
                        <li key={benefit.id}>
                            <span>
                                <LandingCheckIcon/>
                            </span>

                            {benefit.label}
                        </li>
                    ))}
                </ul>

                {metrics.length > 0 && (
                    <div className="landing-sales-card__metrics">
                        {metrics.map((metric) => (
                            <div key={metric.id}>
                                <strong>
                                    {metric.value}
                                </strong>

                                <span>
                                    {metric.label}
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                <a
                    className="landing-sales-card__action"
                    href={primaryAction.href}
                >
                    {primaryAction.label}

                    <LandingArrowIcon/>
                </a>

                {secondaryAction && (
                    <a
                        className="landing-sales-card__secondary-action"
                        href={secondaryAction.href}
                    >
                        {secondaryAction.label}

                        <LandingArrowIcon/>
                    </a>
                )}
            </div>
        </article>
    );
}
